import { useAppDispatch, useAppSelector } from '../app/hooks';
import { RootState } from '../app/store';
import { UpsellTriggers } from '../components/OmniBar/Omnibar.constants';
import { UPSELL_METRIC_VERSION } from '../constants';
import {
  AgentInterceptionType,
  InfoTransmissionMessage,
  messagingActions,
  TextFrameTransmissionMessage,
} from '../reducers/messagingSlice';
import { selectActiveRestaurantDetails } from '../selectors/restaurant';
import { getMenuUnificationFeatureFlag } from '../utils/session-storage';
import { upsell } from '../utils/upsell';
import useAgentInterception from './agentInterception/useAgentInterception.hooks';

const useTTSMessage = () => {
  const dispatch = useAppDispatch();
  const { sendAgentInterception } = useAgentInterception();
  const { restaurantName } = useAppSelector(selectActiveRestaurantDetails);
  const isBrandMenu = getMenuUnificationFeatureFlag();
  const cart = useAppSelector((state: RootState) => state.cart);

  const selectedItem =
    useAppSelector((state) => state.dialog.selectedItem) ||
    Object.values(cart.cartItems)[Object.values(cart.cartItems).length - 1];

  const sendTTSMessage = (message: string, metadata?: any) => {
    message = message.split('{RESTAURANT_NAME}').join(restaurantName);
    const payload: Partial<TextFrameTransmissionMessage> = {
      data: { payload: message, status: 'final', metadata },
    };
    dispatch(messagingActions.sendMessage(payload as any));
    sendAgentInterception({
      data: {
        type: AgentInterceptionType.TTS_SENT,
      },
    });
  };

  const sendModGroupTTSMessage = (modGroup: any) => {
    const payload: Partial<InfoTransmissionMessage> = {
      data: {
        message: `Mod group heading (${modGroup.name}) is clicked`,
        type: 'METRIC',
      },
    };
    dispatch(messagingActions.sendInfo(payload as any));

    let message = modGroup.description || '',
      metadata = null;

    if (isBrandMenu && modGroup?.is_upsell_prompt) {
      const upsell_attempted = upsell.attempt(
        modGroup,
        selectedItem.name,
        UpsellTriggers.hitlCenterPane,
        modGroup.description || '.',
        modGroup.name
      );
      metadata = {
        upsell_attempted,
        upsell_metric_version: UPSELL_METRIC_VERSION,
      };
    }

    sendTTSMessage(message, metadata);
  };

  return {
    sendModGroupTTSMessage,
    sendTTSMessage,
  };
};

export default useTTSMessage;
